import AwsServerService from "../../../common/util/AwsServerService";
import { convertZohoTimeToLocal } from "../../HR/TimeClock/Util";

let d = {
    "ROWID": 3,
    "CREATEDTIME": "2025-01-21T12:25:59.000Z",
    "MODIFIEDTIME": "2025-01-21T12:25:59.000Z",
    "CREATEDBY": "796093033",
    "MODIFIEDBY": null,
    "TaskFlowId": 15,
    "ReminderType": "Popup",
    "Status": "752",
    "Attendees": [
        "Zoho Users_796093033"
    ],
    "TriggerType": "LT",
    "TriggerTime": {
        "D": "",
        "H": "00:01",
        "T": 0
    },
    // "Recursion": {
    //     "Time": "2025-01-21T11:19:01.435Z",
    //     "EndBy": "Never",
    //     "OnDay": 21,
    //     "Repeat": "Daily",
    //     "OnMonth": "OnDay",
    //     "MonthDay": "Tuesday",
    //     "EventDate": "2025-01-21T11:19:01.435Z",
    //     "MonthStep": "1",
    //     "WeeklyDay": "Tuesday",
    //     "WhichMonth": "1",
    //     "DailyInterval": "Every",
    //     "DailyIntervalCount": "1"
    // },
    "IsRecurring": 0
}
const addReminders = async ({ module, messageId,Recursion, reminderHeading, userEmail, sendAs, reminderTime }) => {
     
    let userInfo = JSON.parse(localStorage.getItem("userinfo"));
    let payload = {
        // "type": data.reminders.action,
        "module": module,
        "messageId": messageId,
        "reminderHeading": reminderHeading,
        "userEmail": userEmail,
        "attendees": userEmail,
        "sendAs": sendAs.toUpperCase(),
        "Recursion": Recursion,
        // "reminderType":"At specific time",
    };
    // if (parseInt(d.minutes) < 0) {
    //     payload.reminderType = "before";
    // } else {
    //     payload.reminderType = "after"
    // }
    payload.reminderTime = convertZohoTimeToLocal(reminderTime, "US", 0);
    // reminders.push(payload);
    AwsServerService.AddReminders(payload).then(res => {
         
    }).catch(e=>{
        console.log(e);
    })
}

const assigneeEmailsfromModuleUsers=({ModuleUsers,Assignees,ZohoUsers,Roles,lookUpDeal,UserRoles})=>{
      
    return new Promise((resolve, reject) => {
        let str = '';
        if (Assignees && Assignees?.length > 0) {
            Assignees.forEach(a => {
                if (a.AttendeeType=="Role") {
                    let user=Roles?.find(e=>e.ROWID==a.Attendee); 
                    if(user?.RoleType=='Deal'){
                      let userId=UserRoles?.find(el=>el.RoleId==a.Attendee && el.ProjectId==lookUpDeal.Deal_Name)?.UserId;
                      userId = Object.values(ModuleUsers || {}).flat()?.find(k => k.id == userId)?.Email
                      str += userId + ","
                    }else if(user?.RoleType == 'Account'){ 
                      let userId=UserRoles?.find(el=>el.RoleId==a.Attendee && el.ProjectId==lookUpDeal?.Account_Name?.id)?.UserId;
                      userId = Object.values(ModuleUsers || {}).flat()?.find(k => k.id == userId)?.Email
                      str += userId + ","
                    }else if(user?.RoleType == 'Zoho'){
                      let mail = ZohoUsers?.find(e=>e.zuid == a.Attendee)?.email;
                      str += mail + ","
                    }else if(user?.Role == 'Vendor'){
            
                    } 
                } else {
                    // let userDetails = a.Attendee.split("_");
                    if (a.AttendeeType == "Zoho") {
                        let user = ZohoUsers?.find(k => k.zuid == a.Attendee);
                        if (user && user.email) {
                            str += user.email + ","
                        }
                    } else {
                        let user = Object.values(ModuleUsers || {}).flat()?.find(k => k.id == a.Attendee);
                        if (user && user.Email) {
                            str += user.Email + ","
                        }
                    }
                }
            })
        }
        resolve(str);
    })
    
}

export function checkReminder({data,ModuleUsers,ZohoUsers,type,Roles,lookUpDeal,UserRoles}) {
     
    // data = d;
    let reminderTime = new Date();
    // if (!data.IsRecurring) {
        console.log(data)
        if (data.TriggerType == "LT") {
            let triggerTimeInMins = 0;
            if (data?.TriggerTime?.D) {
                triggerTimeInMins += Number(data?.TriggerTime?.D) * 1440;
            }
            if (data?.TriggerTime?.H) {
                let arr = data?.TriggerTime?.H.split(":");
                triggerTimeInMins += (Number(arr[0]) * 60 + Number(arr[1]));
            }

            reminderTime.setMinutes(triggerTimeInMins + reminderTime.getMinutes());
            
            assigneeEmailsfromModuleUsers({
                Assignees:data.Attendees,
                lookUpDeal:lookUpDeal,
                Roles:Roles,
                UserRoles:UserRoles,
                ModuleUsers:ModuleUsers,
                ZohoUsers:ZohoUsers,
            }).then(res=>{
                let userStr = res;
                data.ReminderType && data.ReminderType.split(",").map(a=>{
                    addReminders({
                        module: "Task",
                        messageId: data.ROWID,
                        reminderHeading: data.description,
                        reminderTime: reminderTime,
                        sendAs: a.toUpperCase(),
                        userEmail: userStr,
                        Recursion: data.IsRecurring?data.Recursion:0,
                    })
                })
            }).catch(e=>{
                console.log(e);
            })

        }else if (data.TriggerType == "OSC" || data.TriggerType == "OSE") {
        
            reminderTime.setMinutes(2 + reminderTime.getMinutes());
        
            assigneeEmailsfromModuleUsers({
                Assignees:data.Attendees,
                lookUpDeal:lookUpDeal,
                Roles:Roles,
                UserRoles:UserRoles,
                ModuleUsers:ModuleUsers,
                ZohoUsers:ZohoUsers,
            }).then(res=>{
                let userStr = res;
                data.ReminderType && data.ReminderType.split(",").map(a=>{
                    addReminders({
                        module: "Task",
                        messageId: data.ROWID,
                        reminderHeading: data.description,
                        reminderTime: reminderTime,
                        sendAs: a.toUpperCase(),
                        userEmail: userStr,
                        Recursion: data.IsRecurring?data.Recursion:0,
                    })
                })
            }).catch(e=>{
                console.log(e);
            })

        }
    // } 
}
// checkReminder({ data: d })